import { render, staticRenderFns } from "./CrmConfigurations.vue?vue&type=template&id=d3904226"
import script from "./CrmConfigurations.vue?vue&type=script&lang=js"
export * from "./CrmConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports